import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { HID } from "@/constants/cosecIds";

export default function FinalCta() {
  return (
    <section className="py-20 md:py-28">
      <div className="container-cv">
        <div className="relative rounded-3xl overflow-hidden border border-border bg-gradient-to-br from-white via-secondary/40 to-accent/10 p-8 md:p-14">
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-accent/15 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-primary/10 blur-3xl pointer-events-none" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <span className="section-eyebrow">Take control</span>
              <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.04]">
                Take Control of Company Secretarial Work with{" "}
                <span className="text-accent">CoSec.</span>
              </h2>
              <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
                Replace spreadsheets, scattered records, and manual admin with one
                secure platform. CoSec helps teams manage filings, statutory records,
                governance tasks, and compliance workflows faster with fewer errors.
              </p>
              <p className="mt-4 font-display text-lg font-bold text-primary">
                See how CoSec can save time, reduce risk, and simplify daily operations.
              </p>

              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <Button
                  asChild
                  data-testid={HID.finalBookDemo}
                  className="h-12 px-7 bg-primary hover:bg-primary/90 text-primary-foreground font-bold text-base"
                >
                  <a href="/contact">
                    Book a Demo <ArrowRight className="ml-2 h-4 w-4" />
                  </a>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  className="h-12 px-7 border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground font-bold text-base"
                >
                  <a href="/coverify">Explore CoVerify →</a>
                </Button>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-2xl border border-border bg-white p-6 shadow-lg">
                <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-accent">
                  <ShieldCheck className="h-4 w-4" /> Trusted UK platform
                </div>
                <p className="mt-3 text-sm text-primary/80 leading-relaxed">
                  Trusted by UK businesses for secure company secretarial management.
                </p>
                <div className="mt-4 grid grid-cols-3 gap-2">
                  {[
                    { k: "10+", l: "Years compliance" },
                    { k: "126+", l: "Entities live" },
                    { k: "0", l: "Missed filings" },
                  ].map((s, i) => (
                    <div key={i} className="rounded-md bg-secondary/60 p-2.5 text-center">
                      <div className="font-display text-lg font-bold text-primary">{s.k}</div>
                      <div className="text-[10px] text-muted-foreground">{s.l}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
